import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import classnames from 'classnames';
import { Scrollbars } from 'react-custom-scrollbars';
import { formatBytes } from 'helpers/utils';
import { Close } from 'components/Icons';

// https://github.com/malte-wessel/react-custom-scrollbars
const styles = theme => ({
  content: {
    backgroundColor: '#F4F8F9',
    flexGrow: 1,
    overflowX: 'hidden',
    overflowY: 'scroll',
    padding: theme.spacing(2),
  },
  paper: {
    padding: 20,
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    backgroundColor: '#FFFFFF',
    borderRadius: 4,
    // boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)',
    // transition: 'all 0.3s cubic-bezier(.25,.8,.25,1)',
  },
  libraryPaper: {
    paddingTop: 20,
    paddingRight: 15,
    paddingBottom: 20,
    paddingLeft: 20,
    height: '40vh',
  },
  libraryScroll: {
    marginTop: 5,
    padding: 10,
  },
  title: {
    fontSize: '1em',
    fontWeight: 'bold',
    color: '#000',
  },
  row: {
    display: 'flex',
    padding: 5,
    marginLeft: 5,
    marginRight: 10,
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  },
  rowHover: {
    '&:hover': {
      backgroundColor: '#bbb',
      color: '#fff',
    },
  },
  rowSelected: {
    backgroundColor: '#4EA2FF',
    color: '#fff',
  },
  rowMid: {
    fontSize: '0.8em',
    flexGrow: 1,
  },
  rowRight: {},
  circleNew: {
    borderRadius: '50%',
    width: 7,
    maxWidth: 7,
    minWidth: 7,
    height: 7,
    maxHeight: 7,
    minHeight: 7,
    marginRight: 7,
    marginLeft: 4,
    marginTop: 3,
    backgroundColor: '#d34521',
  },
  circleProcessing: {
    borderRadius: '50%',
    width: 7,
    maxWidth: 7,
    minWidth: 7,
    height: 7,
    maxHeight: 7,
    minHeight: 7,
    marginRight: 7,
    marginLeft: 4,
    marginTop: 3,
    backgroundColor: '#d3d321',
  },
  circleDone: {
    borderRadius: '50%',
    width: 7,
    maxWidth: 7,
    minWidth: 7,
    height: 7,
    maxHeight: 7,
    minHeight: 7,
    marginRight: 7,
    marginLeft: 4,
    marginTop: 3,
    backgroundColor: '#7ED321',
  },
  delWhite: {
    '&:hover': {
      color: '#fff',
    },
  },
  delBlue: {
    '&:hover': {
      color: '#4EA2FF',
    },
  },
});

class Library extends Component {
  renderRow = encoding => {
    const { _id, file } = encoding;
    const { classes } = this.props;
    const selected = !!(
      this.props.selected && // selected campaign
      this.props.selected.file && //
      file._id === this.props.selected.file._id
    );
    const delColor = selected ? '#fff' : '#4EA2FF';

    const encodingNew = encoding.status === 'new' ? true : false;
    const encodingProcessing = encoding.status === 'processing' ? true : false;

    return (
      <div
        key={file._id}
        className={classnames(
          classes.row,
          selected ? classes.rowSelected : classes.rowHover
        )}
        onClick={() => {
          this.props.selectEncoding(encoding);
        }}
      >
        <div
          className={classnames(
            encodingNew
              ? classes.circleNew
              : encodingProcessing
              ? classes.circleProcessing
              : classes.circleDone
          )}
        />
        <div className={classes.rowMid}>
          {`${file.fileName} (${formatBytes(file.size)})`}
        </div>
        <div className={classes.rowRight}>
          <Close
            size="small"
            color={delColor}
            onClick={() => {
              this.props.confirmDelete(_id, file.fileName);
            }}
          />
        </div>
      </div>
    );
  };
  componentDidMount() {
    this.props.history.push('/dashboard');
  }
  render() {
    const { classes } = this.props;

    // console.log('PROPS', this.props);

    return (
      <div className={classnames(classes.paper, classes.libraryPaper)}>
        <span className={classes.title}>Library</span>
        <Scrollbars className={classes.libraryScroll}>
          {this.props.encodings.map(encoding => {
            return this.renderRow(encoding);
          })}
        </Scrollbars>
      </div>
    );
  }
}

Library.propTypes = {
  classes: PropTypes.object.isRequired,
  encodings: PropTypes.array.isRequired,
  selectFileFromLibrary: PropTypes.func,
  deleteEncoding: PropTypes.func,
};

export default withStyles(styles)(Library);
